import React, { useEffect, useState, useRef } from "react";
import classes from "./CategoryPage.module.css";
import { fetchAndroidGamesApi, fetchGamesApi } from "../http/http";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { motion } from "framer-motion";
import Footer from "../component/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const CategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [games, setGames] = useState([]);
  const [allGames, setAllGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popularGames, setPopularGames] = useState([]);
  const [androidGames, setAndroidGames] = useState([]);
  const [activeCategory, setActiveCategory] = useState(0);
  const [categoryType, setCategoryType] = useState("");

  const selectedLanguageId = Number(
    useSelector((state) => state?.persisted?.languageSlice?.language ?? 1),
  );

  const { t } = useTranslation();

  const categoriesRef = useRef(null);

  const scrollCategories = (direction) => {
    const container = categoriesRef.current;
    if (!container) return;

    const scrollAmount = Math.min(container.clientWidth * 0.8, 320);

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const location = useLocation();

  useEffect(() => {
    setCategoryType(location.state?.category_type || "html");
    if (location.state?.category_id) {
      setActiveCategory(location?.state?.category_id);
      fetchGames(location?.state?.category_id, selectedLanguageId);
    } else {
      navigate("/home");
    }
  }, [location, selectedLanguageId]);

  const navigate = useNavigate();

  const pickRandomK = (arr, k = 20) => {
    const n = Array.isArray(arr) ? arr.length : 0;
    if (n <= k) return arr ? [...arr] : [];

    const idx = new Set();
    while (idx.size < k) {
      idx.add(Math.floor(Math.random() * n));
    }
    return Array.from(idx, (i) => arr[i]);
  };

  const fetchGames = async (cid, language) => {
    try {
      setLoading(true);
      // means android games hy
      const response = await fetchGamesApi(language);
      const response2 = await fetchAndroidGamesApi(language);
      setAndroidGames(response2?.data?.games);
      setAllGames(response?.data?.games);
      setGames(() =>
        response?.data?.games?.filter((d) => d?.category_id === cid),
      );
      setCategories(response?.data?.categories);
      setPopularGames(pickRandomK(response?.data?.games, 6));
    } catch (error) {
      console.log(error, "error--");
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (category) => {
    setLoading(true);
    setActiveCategory(category?.id);
    location.state.category_id = category?.id;
    setCategoryType(category?.category_type || "");
    if (category?.category_type === "all") {
      setGames(allGames);
      setPopularGames(pickRandomK(allGames, 6));
    } else if (category?.category_type === "android") {
      setGames(androidGames);
      setPopularGames(pickRandomK(androidGames, 6));
    } else {
      setGames(() => allGames?.filter((d) => d?.category_id === category?.id));
      setPopularGames(
        pickRandomK(
          allGames?.filter((d) => d?.category_id === category?.id),
          6,
        ),
      );
    }

    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  const renderSkeletonCards = (count, firstLarge = false) => {
    return Array.from({ length: count }).map((_, index) => {
      const isLarge = firstLarge && index === 0;

      return (
        <div
          key={`skeleton-${firstLarge ? "top" : "bottom"}-${index}`}
          className={`${classes.game_card} ${
            isLarge ? classes.large_card : classes.small_card
          } ${classes.skeletonCard}`}
        >
          <div className={classes.skeletonImage}></div>

          <div className={classes.skeletonContent}>
            <div className={classes.skeletonMetaRow}>
              <span className={classes.skeletonMeta}></span>
              <span className={classes.skeletonChip}></span>
            </div>

            <span
              className={`${classes.skeletonTitle} ${
                isLarge
                  ? classes.skeletonTitleLarge
                  : classes.skeletonTitleSmall
              }`}
            ></span>

            <span
              className={`${classes.skeletonTitle} ${
                isLarge
                  ? classes.skeletonTitleMedium
                  : classes.skeletonTitleTiny
              }`}
            ></span>
          </div>
        </div>
      );
    });
  };

  return (
    <main className={classes.main}>
      <section className={classes.category_section}>
        <div className={classes.category_topbar}>
          <motion.button
            type="button"
            className={classes.back_btn}
            onClick={() => navigate(-1)}
            whileHover={{ x: -3, scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
          >
            <FaArrowLeft />
          </motion.button>

          <div className={classes.category_heading_container}>
            <span className={classes.category_kicker}>{t("74")}</span>
            <h1 className={classes.category_heading}>{t("75")}</h1>
            <p className={classes.category_desc}>{t("76")}</p>
          </div>
        </div>

        <div className={classes.categories_wrap}>
          <div className={classes.categories_top}>
            <span className={classes.categories_label}>{t("77")}</span>
            <div className={classes.categories_top_right}>
              <span className={classes.categories_count}>
                {games?.length || androidGames?.length || 0} {t("63")}
              </span>

              <div className={classes.category_nav}>
                <button
                  type="button"
                  className={classes.category_nav_btn}
                  onClick={() => scrollCategories("left")}
                >
                  <FaArrowLeft />
                </button>

                <button
                  type="button"
                  className={classes.category_nav_btn}
                  onClick={() => scrollCategories("right")}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </div>

          <div className={classes.categories_slider}>
            <div className={classes.categories} ref={categoriesRef}>
              {categories?.map((cat, idx) => {
                return (
                  <button
                    key={idx}
                    className={
                      activeCategory === cat?.id
                        ? classes.category_active
                        : classes.category_btn
                    }
                    onClick={() => handleCategoryChange(cat)}
                  >
                    <span>{t(cat?.category_name)}</span>
                    <span className={classes.category_count_badge}>
                      {cat?.active_games_count}
                      {/* {games?.length ?? androidGames?.lenght} */}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {loading ? (
        <>
          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {renderSkeletonCards(5, true)}
            </section>
          </section>
        </>
      ) : // android games showcase
      categoryType === "android" ? (
        <>
          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {androidGames?.slice(0, 5).map((game, index) => {
                const isLarge = index === 0 || index === 5;

                return (
                  <motion.article
                    key={`${game.id}-${index}`}
                    layout
                    whileHover={{ y: -10, scale: 1.015 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                    onClick={() => (window.location.href = game.game_url)}
                    className={`${classes.game_card} ${
                      isLarge ? classes.large_card : classes.small_card
                    }`}
                  >
                    <div className={classes.media_wrap}>
                      <img
                        src={game.game_banner}
                        loading="lazy"
                        alt={game.game_name}
                        className={classes.game_image}
                      />
                    </div>

                    <div className={classes.overlay_in_card} />
                    <div className={classes.overlay_top} />
                    <div className={classes.card_border_glow} />
                    <div className={classes.card_shine} />

                    <div
                      className={`${classes.card_content} ${
                        isLarge
                          ? classes.card_content_large
                          : classes.card_content_small
                      }`}
                    >
                      <div className={classes.meta_row}>
                        <p className={classes.game_category}>{t("120")}</p>
                        <span className={classes.play_chip}>{t("121")}</span>
                      </div>

                      <h3
                        className={`${classes.game_name} ${
                          isLarge ? classes.large_title : classes.small_title
                        }`}
                      >
                        {game.game_name}
                      </h3>

                      <div className={classes.bottom_accent} />
                    </div>
                  </motion.article>
                );
              })}
            </section>
          </section>

          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {androidGames?.slice(5).map((game, index) => {
                const isLarge = false;

                return (
                  <motion.article
                    key={`${game.id}-${index}`}
                    layout
                    whileHover={{ y: -10, scale: 1.015 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                    className={`${classes.game_card} ${
                      isLarge ? classes.large_card : classes.small_card
                    }`}
                    onClick={() => (window.location.href = game.game_url)}
                  >
                    <div className={classes.media_wrap}>
                      <img
                        src={game.game_banner}
                        alt={game.game_name}
                        loading="lazy"
                        className={classes.game_image}
                      />
                    </div>

                    <div className={classes.overlay_in_card} />
                    <div className={classes.overlay_top} />
                    <div className={classes.card_border_glow} />
                    <div className={classes.card_shine} />

                    <div
                      className={`${classes.card_content} ${
                        isLarge
                          ? classes.card_content_large
                          : classes.card_content_small
                      }`}
                    >
                      <div className={classes.meta_row}>
                        <p className={classes.game_category}>{t("120")}</p>
                        <span className={classes.play_chip}>{t("121")}</span>
                      </div>

                      <h3
                        className={`${classes.game_name} ${
                          isLarge ? classes.large_title : classes.small_title
                        }`}
                      >
                        {game.game_name}
                      </h3>

                      <div className={classes.bottom_accent} />
                    </div>
                  </motion.article>
                );
              })}
            </section>
          </section>

          <Footer />
        </>
      ) : (
        <>
          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {games?.slice(0, 5).map((game, index) => {
                const isLarge = index === 0 || index === 5;

                return (
                  <motion.article
                    key={`${game.id}-${index}`}
                    layout
                    whileHover={{ y: -10, scale: 1.015 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                    onClick={() =>
                      navigate("/game", {
                        state: {
                          game: game,
                        },
                      })
                    }
                    className={`${classes.game_card} ${
                      isLarge ? classes.large_card : classes.small_card
                    }`}
                  >
                    <div className={classes.media_wrap}>
                      <img
                        src={game.game_banner}
                        loading="lazy"
                        alt={game.game_name}
                        className={classes.game_image}
                      />
                    </div>

                    <div className={classes.overlay_in_card} />
                    <div className={classes.overlay_top} />
                    <div className={classes.card_border_glow} />
                    <div className={classes.card_shine} />

                    <div
                      className={`${classes.card_content} ${
                        isLarge
                          ? classes.card_content_large
                          : classes.card_content_small
                      }`}
                    >
                      <div className={classes.meta_row}>
                        <p className={classes.game_category}>
                          {t(game.category_name)}
                        </p>
                        <span className={classes.play_chip}>{t("65")}</span>
                      </div>

                      <h3
                        className={`${classes.game_name} ${
                          isLarge ? classes.large_title : classes.small_title
                        }`}
                      >
                        {game.game_name}
                      </h3>

                      <div className={classes.bottom_accent} />
                    </div>
                  </motion.article>
                );
              })}
            </section>
          </section>

          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {games?.slice(5).map((game, index) => {
                const isLarge = false;

                return (
                  <motion.article
                    key={`${game.id}-${index}`}
                    layout
                    whileHover={{ y: -10, scale: 1.015 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                    className={`${classes.game_card} ${
                      isLarge ? classes.large_card : classes.small_card
                    }`}
                    onClick={() =>
                      navigate("/game", {
                        state: {
                          game: game,
                        },
                      })
                    }
                  >
                    <div className={classes.media_wrap}>
                      <img
                        src={game.game_banner}
                        alt={game.game_name}
                        loading="lazy"
                        className={classes.game_image}
                      />
                    </div>

                    <div className={classes.overlay_in_card} />
                    <div className={classes.overlay_top} />
                    <div className={classes.card_border_glow} />
                    <div className={classes.card_shine} />

                    <div
                      className={`${classes.card_content} ${
                        isLarge
                          ? classes.card_content_large
                          : classes.card_content_small
                      }`}
                    >
                      <div className={classes.meta_row}>
                        <p className={classes.game_category}>
                          {t(game.category_name)}
                        </p>
                        <span className={classes.play_chip}>{t("65")}</span>
                      </div>

                      <h3
                        className={`${classes.game_name} ${
                          isLarge ? classes.large_title : classes.small_title
                        }`}
                      >
                        {game.game_name}
                      </h3>

                      <div className={classes.bottom_accent} />
                    </div>
                  </motion.article>
                );
              })}
            </section>
          </section>

          <Footer />
        </>
      )}
    </main>
  );
};

export default CategoryPage;
